import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  onSnapshot,
  orderBy,
  where,
} from "firebase/firestore";
import { db, auth } from "../FirebaseConfig";

const LeaderBoard = () => {
  const [profiles, setProfiles] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  useEffect(() => {
    const q = query(
      collection(db, "profiles"),
      where("referralCode", "!=", null),
      orderBy("referralCount", "desc")
    );

    const unsub = onSnapshot(q, (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProfiles(list);
    });

    const user = auth.currentUser;
    if (user) setCurrentUserId(user.uid);

    return () => unsub();
  }, []);

  const scrollToUser = () => {
    const el = document.getElementById(`user-${currentUserId}`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const getMedal = (index) => {
    if (index === 0) return "🥇";
    if (index === 1) return "🥈";
    if (index === 2) return "🥉";
    return `#${index + 1}`;
  };

  // Pagination calculations
  const startIndex = (currentPage - 1) * usersPerPage;
  const currentProfiles = profiles.slice(startIndex, startIndex + usersPerPage);
  const totalPages = Math.ceil(profiles.length / usersPerPage);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div className="p-6 max-w-2xl mx-auto text-white bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl shadow-lg">
      <h1 className="text-3xl font-bold text-center mb-2 text-green-400">
        ₦20,000 Referral Giveaway Leaderboard
      </h1>
      <p className="text-center text-sm mb-4 text-gray-300">
        (1st Place: ₦10,000 | 2nd Place: ₦6,000 | 3rd Place: ₦4,000)
      </p>
      <p className="text-center text-xs mb-6 text-gray-400 italic">
        Valid for 1 month until December 1st, 2025
      </p>

      <button
        onClick={scrollToUser}
        className="mb-6 px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg w-full text-white font-medium transition duration-300 ease-in-out shadow-md"
      >
        Find My Referral Count
      </button>

      <div className="space-y-4">
        {currentProfiles.length > 0 ? (
          currentProfiles.map((user, index) => (
            <div
              key={user.id}
              id={`user-${user.id}`}
              className={`flex items-center gap-4 p-4 rounded-lg bg-white/10 backdrop-blur-sm transition duration-200 hover:bg-white/20 ${
                user.id === currentUserId ? "border-2 border-green-400 shadow-md" : ""
              }`}
            >
              <span className="text-xl w-8 font-bold">
                {getMedal(startIndex + index)}
              </span>
              <img
                src={
                  user.photoURL ||
                  `https://ui-avatars.com/api/?name=${user.name || "User"}&background=random`
                }
                alt={user.name}
                className="w-12 h-12 rounded-full object-cover border-2 border-gray-600"
              />
              <div className="flex-1">
                <p className="font-semibold text-lg">{user.name || "Unnamed User"}</p>
                <p className="text-sm text-gray-300">
                  Referral Code: {user.referralCode}
                </p>
              </div>
              <div className="text-right">
                <p className="text-xl font-bold text-green-300">{user.referralCount || 0}</p>
                <p className="text-xs text-gray-400">referrals</p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-300 py-4 bg-white/10 rounded-lg">No referral entries yet.</p>
        )}
      </div>

      {/* Pagination Buttons */}
      {totalPages > 1 && (
        <div className="flex justify-between items-center mt-6">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded-lg font-medium transition duration-300 ${
              currentPage === 1
                ? "bg-gray-600 cursor-not-allowed text-gray-400"
                : "bg-green-600 hover:bg-green-700 text-white shadow-md"
            }`}
          >
            Previous
          </button>

          <span className="text-sm text-gray-300">
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded-lg font-medium transition duration-300 ${
              currentPage === totalPages
                ? "bg-gray-600 cursor-not-allowed text-gray-400"
                : "bg-green-600 hover:bg-green-700 text-white shadow-md"
            }`}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default LeaderBoard;